import styled from "styled-components"

export const ProjectLayout = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
`
export const ProjectMenuColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: ${(props) => props.theme.layoutSizes.projectMenuWidth}px;
    background: ${(props) => props.theme.projectMenuBackground};
    border-left: 1px solid ${(props) => props.theme.projectMenuBorderColor};
    border-right: 1px solid ${(props) => props.theme.projectMenuBorderColor};
    border-bottom: 1px solid ${(props) => props.theme.projectMenuBorderColor};
`
export const ProjectMenuContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 0;
    }
`
export const ProjectContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: calc(100% - ${(props) => props.theme.layoutSizes.projectMenuWidth}px);
`
export const ProjectContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    width: 100%;
`
